import type { InMemoryCacheConfig } from '@apollo/client';
import possibleTypesResult from '../generated/possible-types';
import { typePolicies } from '../graphql/typePolicies';
import { TrackingCache } from './TrackingCache';

type Options = Omit<
  InMemoryCacheConfig,
  'addTypename' | 'typePolicies' | 'possibleTypes'
>;

export function initCache(config?: Options) {
  let cache = new TrackingCache({
    ...config,
    typePolicies,
    possibleTypes: possibleTypesResult.possibleTypes,
  });

  if (
    typeof window !== 'undefined' &&
    (window as any).__FRAME_DEV_WATCH_CACHE__
  ) {
    // Allows a client (Chrome Extension, Playwright, ...) to optionally add a cache listener/override for easier debugging.
    cache = (window as any).__FRAME_DEV_WATCH_CACHE__(cache);
  }

  return cache;
}
